import { render, staticRenderFns } from "./Ring.vue?vue&type=template&id=25be3b10&scoped=true&"
import script from "./Ring.vue?vue&type=script&lang=js&"
export * from "./Ring.vue?vue&type=script&lang=js&"
import style0 from "./Ring.vue?vue&type=style&index=0&id=25be3b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be3b10",
  null
  
)

export default component.exports